import { InferType, array, object, string } from 'yup';

export type ShareDashboardFieldValues = InferType<typeof shareDashboardSchema>;

export const shareDashboardSchema = object({
  id: string().required(),
  targetUsers: array<{ label: string; value: string }>().defined(),
}).required();
